import TinySlider from "./TinySlider.vue";
// @ts-ignore
export type { TinySliderElement } from "./TinySlider.vue";

export default TinySlider;
